// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NZC-","right":"styles_right__3uI5-"};